export default {
  es: {
    'app.envios.index.hoc.modal.body.one': 'Va a enviar un correo.',
    'app.envios.index.hoc.modal.body.many': 'Va a enviar un total de {count, number} correos.',
    'app.envios.index.hoc.modal.body.zero': 'Va a enviar un newsletter a todos los contactos de la base de datos.',
    'app.envios.index.hoc.select.template': 'Seleccione la template a enviar',
    'app.envios.index.hoc.modal.title': 'Envío de correos',
    'app.envios.index.hoc.modal.confirm': 'enviar',
    'app.envios.index.hoc.modal.close': 'close',
    'app.envios.index.alert.success': 'El envío se realizado correctamente'
  },
};